// extracted by mini-css-extract-plugin
module.exports = {"container":"EditableHeader_container__2O_cD","containerDefault":"EditableHeader_containerDefault__27-45"};